const DEFAULT_API_BASE_URL = 'http://localhost:5000/api';
const DEFAULT_MAIN_APP_BASE_URL = 'http://localhost:3000';
const DEFAULT_CLUBS_APP_BASE_URL = 'http://localhost:3002';
const DEFAULT_WALLET_APP_BASE_URL = 'http://localhost:3001';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL?.trim() || DEFAULT_API_BASE_URL
);

export const MAIN_APP_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_MAIN_APP_URL?.trim() || DEFAULT_MAIN_APP_BASE_URL
);

export const CLUBS_APP_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_CLUBS_APP_URL?.trim() || DEFAULT_CLUBS_APP_BASE_URL
);

export const WALLET_APP_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_WALLET_APP_URL?.trim() || DEFAULT_WALLET_APP_BASE_URL
);